import React from 'react'
import ClientLocations from '../../client/ClientLocations'
import V3ProfileRouteShell from '../profile/V3ProfileRouteShell'

export default function V3ClientLocationsPage() {
  return (
    <V3ProfileRouteShell>
      <ClientLocations visualVariant="v3" />
    </V3ProfileRouteShell>
  )
}

